import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetPaymentSumIsError = IAction<ETicketPayment.SET_PAYMENT_SUM_IS_ERROR, boolean>

const setPaymentSumIsError = (status: boolean): TSetPaymentSumIsError => ({
    type: ETicketPayment.SET_PAYMENT_SUM_IS_ERROR,
    payload: status,
});

export default setPaymentSumIsError;
